import {DialogWhereIsDatevClientIdState} from './dialog-where-is-datev-client-id.state';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {DialogsState} from '../../+store/dialogs.state';


export class DialogWhereIsDatevClientIdSelectors {

  private static readonly _feature = createFeatureSelector<DialogsState>('dialogs');

  private static readonly _slice = createSelector(
    this._feature,
    (state): DialogWhereIsDatevClientIdState => state.dialogWhereIsDatevClientId,
  );

  public static readonly isOpen = createSelector(
    this._slice,
    (state) => state.isOpen,
  );

}
